type EnvironmentConfig = {
  ADMIN_BASE_URL?: string;
  API_BASE_URL?: string;
  APP_ENV: string;
  GOOGLE_TAG_MANAGER_ID?: string;
  IPIFY_API_URL?: string;
  IPINFO_API_URL?: string;
  MODE: string;
  PUBLIC_API_CLIENT_KEY?: string;
  PUBLIC_IPINFO_TOKEN?: string;
  PUBLIC_STRIPE_APP_CLIENT_KEY?: string;
  PUBLIC_STRIPE_APP_TOKEN?: string;
  PUBLIC_THEME_CLIENT_KEY?: string;
  RECAPTCHA_SITE_KEY?: string;
  REPORTING_BASE_URL?: string;
  S3_BUCKET_URL?: string;
  SITE: string;
  SITE_URL?: string;
  SHOW_ERROR_DETAILS?: string;
  SOCIAL_POSTING_BASE_URL?: string;
  SOCKET_URL_ADMIN?: string;
  SOCKET_URL_API?: string;
  STRIPE_MICRO_SERVICE_API_BASE_URL?: string;
  STRIPE_PUBLISHABLE_KEY?: string;
  WHITE_LABELED_DOMAIN_URL?: string;
};

export const ENV: EnvironmentConfig = {
  MODE: import.meta.env.MODE || "development",
  APP_ENV: import.meta.env.VITE_APP_ENV || "development",
  SITE: import.meta.env.VITE_APP_SITE || "hyperlocology",
  SHOW_ERROR_DETAILS: import.meta.env.VITE_APP_SHOW_ERROR_DETAILS,
  API_BASE_URL: import.meta.env.VITE_APP_API_BASE_URL,
  ADMIN_BASE_URL: import.meta.env.VITE_APP_ADMIN_BASE_URL,
  REPORTING_BASE_URL: import.meta.env.VITE_APP_REPORTING_BASE_URL,
  STRIPE_MICRO_SERVICE_API_BASE_URL: import.meta.env
    .VITE_APP_STRIPE_MICRO_SERVICE_API_BASE_URL,
  SOCKET_URL_ADMIN: import.meta.env.VITE_APP_SOCKET_URL_ADMIN,
  SOCKET_URL_API: import.meta.env.VITE_APP_SOCKET_URL_API,
  SITE_URL: import.meta.env.VITE_APP_SITE_URL,
  WHITE_LABELED_DOMAIN_URL: import.meta.env.VITE_APP_WHITE_LABELED_DOMAIN_URL,
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY,
  PUBLIC_STRIPE_APP_TOKEN: import.meta.env.VITE_APP_PUBLIC_STRIPE_APP_TOKEN,
  PUBLIC_STRIPE_APP_CLIENT_KEY: import.meta.env
    .VITE_APP_PUBLIC_STRIPE_APP_CLIENT_KEY,
  GOOGLE_TAG_MANAGER_ID: import.meta.env.VITE_APP_GOOGLE_TAG_MANAGER_ID,
  RECAPTCHA_SITE_KEY: import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY,
  S3_BUCKET_URL: import.meta.env.VITE_APP_S3_BUCKET_URL,
  PUBLIC_API_CLIENT_KEY: import.meta.env.VITE_APP_PUBLIC_API_CLIENT_KEY,
  PUBLIC_THEME_CLIENT_KEY: import.meta.env.VITE_APP_PUBLIC_THEME_CLIENT_KEY,
  PUBLIC_IPINFO_TOKEN: import.meta.env.VITE_APP_PUBLIC_IPINFO_TOKEN,
  SOCIAL_POSTING_BASE_URL: import.meta.env.VITE_APP_SOCIAL_POSTING_BASE_URL,
  IPINFO_API_URL: import.meta.env.VITE_APP_IPINFO_API_URL,
  IPIFY_API_URL: import.meta.env.VITE_APP_IPIFY_API_URL,
};

export const IS_PROD = ENV.APP_ENV === "production";
export const IS_DEV = ENV.APP_ENV === "development";
export const BRAND_REQUEST_TEMPLATE_BASE_URL = `${ENV.S3_BUCKET_URL}brands/brand-requests/sample-templates`;
